import { IncomingMessage } from 'http'

export const isJobsUrl = (req: IncomingMessage) => {
  return req?.url?.includes('-jobs')
}

export const getAutologinRedirectUrl = (req, autologinToken) => {
  const tokenEncoded = encodeURIComponent(autologinToken)
  const tokenPattern = new RegExp(`altkn=(${autologinToken}|${tokenEncoded})`, 'g')
  const autologinRedirectUrl = req.url.replace(tokenPattern, '')

  if (autologinRedirectUrl.slice(-1) === '?') {
    return autologinRedirectUrl.slice(0, -1)
  }
  return autologinRedirectUrl
}
